/*
2026-06-04 ZD34079 Updated prices to remove trailing zeroes
2026-07-31 ZD37868 Updated Add to Cart buttons
*/




import { LitElement, html, css } from 'https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js';

const skioStyles = css`
   /* --- YOUR ORIGINAL CSS (unchanged) --- */
  .skio-plan-picker { display:flex; flex-direction:column; gap:14px; padding:0; border:0; margin-bottom:25px; }
  .skio-plan-picker.skio-cards { gap:14px !important; margin-bottom:14px; }
  .skio-card__header .skio-radio__container {
        display: none;
    }
    .skio-card.one-time {
        padding-top: 0px;
    }
    .skio-card.one-time .skio-card__body {
        margin-top: 0px;
    }
    .skio-card.one-time .skio-card__body button.skio-atc.skio-atc--onetime {
        text-decoration: underline;
        -webkit-text-decoration-style: solid;
                text-decoration-style: solid;
        text-decoration-offset: 0%;
        text-decoration-thickness: 0%;
        -webkit-text-decoration-skip: ink;
                text-decoration-skip-ink: auto;
        color: #2c6b57;
        text-underline-offset: 2px;
        text-decoration:underline;
        margin-top: 0px;
        border: none;
        background: none;
        padding: 0px;
        margin-top: 0px;
        font-family: Roboto;
        font-weight: 400;
        font-style: Regular;
        font-size: 15px;
        leading-trim: NONE;
        line-height: 19.5px;
        letter-spacing: 0%;
    }
    .skio-card__header .skio-card__title {
        display: flex;
        align-items: center;
        gap: 5px;
    }
    .skio-card__header .skio-card__title > svg {
        margin-right: 9px;
    }
  .skio-card {
    /* border:2px solid rgba(0,0,0,.2); */
    /* border-radius:12px; */
    background:#fff;
    padding:18px;
    transition:all .2s ease;
    cursor:default;
    padding-bottom:0px !important;
  }

  .skio-card--selected {
    border-color:#2c6b57;
    box-shadow:0 2px 14px rgba(44,107,87,.12);
  }

  .skio-card__header {
    display:flex;
    align-items:flex-start;
    gap:14px;
  }

  .skio-card__title {
    font-size:22px;
    font-weight:700;
    line-height:1.2;
    margin:0;
    cursor:pointer;
    color:#2b2b2b;
    flex:1;
  }

  .skio-card__price {
    margin-left:auto;
    display:flex;
    flex-direction:column;
    align-items:flex-end;
    gap:4px;
    font-size:28px;
    font-weight:700;
    color:#2b2b2b;
    white-space:nowrap;
  }

  .skio-card__price-now {
    line-height:1;
  }

  .skio-card__price-was {
    font-size:18px;
    font-weight:600;
    color:#717171;
    text-decoration:line-through;
    line-height:1;
  }

  .skio-radio__container {
    position:relative;
    display:flex;
    align-items:center;
    justify-content:center;
    width:24px;
    height:24px;
    flex:0 0 auto;
    margin-top:2px;
  }

  .skio-native-radio {
    position:absolute;
    inset:0;
    opacity:0;
    width:24px;
    height:24px;
    margin:0;
    cursor:pointer;
  }

  .skio-radio-ui {
    width:20px;
    height:20px;
    border:2px solid rgba(0,0,0,.35);
    border-radius:50%;
    display:block;
    position:relative;
    transition:all .2s ease;
    background:#fff;
  }

  .skio-native-radio:checked + .skio-radio-ui {
    border-color:#2c6b57;
    border-width:2px;
  }

  .skio-native-radio:checked + .skio-radio-ui:after {
    content:'';
    position:absolute;
    width:10px;
    height:10px;
    border-radius:50%;
    background:#2c6b57;
    left:50%;
    top:50%;
    transform:translate(-50%,-50%);
  }

  .skio-card__body {
    margin-top:16px;
    overflow:visible;
    max-height:none;
    opacity:1;
    transform:none;
  }
    fieldset.skio-plan-picker.skio-cards {
        border: 1px solid #2C6B57;
        padding: 19px 0px 18px;
        box-shadow: 0px 2px 14px 0px #2C6B571F;
        border-radius: 4px;
    }
  .skio-card__body.is-open {
    margin-top:16px;
    max-height:none;
    opacity:1;
    transform:none;
  }

  .skio-frequency-group {
    display:flex;
    flex-direction:column;
    gap:10px;
    margin-bottom:16px;
  }

  .skio-frequency-radio {
    display:flex;
    align-items:center;
    gap:12px;
    cursor:pointer;
    font-size:16px;
    font-family:inherit;
    color:#2b2b2b;
  }

  .skio-frequency-radio input[type="radio"] {
    width:20px;
    height:20px;
    margin:0;
    accent-color:#2c6b57;
    cursor:pointer;
    flex:0 0 auto;
  }

  .skio-frequency-label {
    flex:1;
  }

  .skio-benefits.skio-benefits--plain {
    margin:0;
    padding:0;
    list-style:none;
  }

  .skio-benefits.skio-benefits--plain li {
    display:flex;
    align-items:flex-start;
    gap:10px;
    margin-bottom:10px;
    font-size:16px;
    color:#2b2b2b;
    line-height:1.4;
  }

  .skio-benefits.skio-benefits--plain li:last-child {
    margin-bottom:0;
  }

  .skio-benefits.skio-benefits--plain li svg {
    flex-shrink:0;
    margin-top:2px;
  }

  .open-modal-btn {
    text-decoration:underline;
    cursor:pointer;
    color:#537a78;
  }

  .skio-onetime-copy {
    margin:0 0 14px;
    font-size:16px;
    color:#2b2b2b;
    line-height:1.4;
  }

  .skio-atc {
    margin-top:16px;
    width:100%;
    border:none;
    border-radius:8px;
    padding:14px 18px;
    font-size:16px;
	letter-spacing: 0.7px;
    font-weight: 450;
    cursor:pointer;
    transition:all .2s ease;
    font-family:inherit;
	display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .skio-atc:hover {
    opacity:.95;
  }

  .skio-atc--subscription {
        background: #305456;
        color: #fff;
        border-radius: 4px;
    }
    .skio-atc--subscription > p {
        font-family: Roboto;
        font-weight: 700;
        font-style: Bold;
        font-size: 16px;
        leading-trim: NONE;
        line-height: 24px;
        letter-spacing: 0%;
        text-align: center;
        color: #fff;
        margin: 0px;
        text-transform: uppercase;
    }

    .skio-atc--subscription > span {
        font-family: Roboto;
        font-weight: 900;
        font-style: Black;
        font-size: 11px;
        leading-trim: NONE;
        line-height: 11.43px;
        letter-spacing: 0.6px;
        text-align: center;
        vertical-align: middle;
        text-transform: uppercase;
        color: #E8BC69;
    }
  .skio-atc--onetime {
    background:#f5f5f5;
    color:#2b2b2b;
    border:1px solid rgba(0,0,0,.12);
  }
   .no-padding {
    margin: 0 !important;
  }

  .getsunmedpdpsusbsavesubsinfocontent .model-main-wrap {
    position:absolute;
    left:50%;
    top:50%;
    transform:translate(-50%,-46%) scale(.98);
    background:#fff;
    height:fit-content;
    max-width:550px;
    width:100%;
    opacity:0;
    transition:opacity .25s ease, transform .25s ease;
    overflow-y:auto;
    margin-top:0;
    -ms-scroll-chaining:none;
    overscroll-behavior:none;
    padding:40px 30px 30px;
    border-radius:8px;
    max-height:88vh;
  }

  .skio-frequency-group-inner-wrap {
        display: flex;
        gap: 8px;
    }
    .skio-frequency-group .label-text {
        font-family: Roboto;
        font-weight: 500;
        font-style: Medium;
        font-size: 13px;
        leading-trim: NONE;
        line-height: 19.5px;
        letter-spacing: 0%;
        color: #305456;
        margin-bottom: 0px;
    }
    .skio-frequency-group-inner-wrap label.skio-frequency-radio {
        position: relative;
        border: 1px solid #578B91;
        border-radius: 4px;
        margin: 0px;
        padding: 9px 15px;
        width: 33.33%;
        background: #F9FAFB;
    }
    .skio-frequency-group-inner-wrap label.skio-frequency-radio > input[type="radio"] {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
    }
    .skio-frequency-group-inner-wrap label.skio-frequency-radio span.skio-frequency-label {
        font-family: Roboto;
        font-weight: 600;
        font-style: SemiBold;
        font-size: 14px;
        leading-trim: NONE;
        line-height: 21px;
        letter-spacing: 0%;
        text-align: center;
        color: #305456;
    }
    .skio-frequency-group-inner-wrap label.skio-frequency-radio:has(input:checked) {
        background: #305456;
    }
    .skio-frequency-group-inner-wrap label.skio-frequency-radio input:checked + span.skio-frequency-label {
        color: #fff;
    }
    .skio-frequency-group.custom-group {
        margin-top: 15px;
        margin-bottom: 0px;
    }
   .skio-frequency-group.custom-group .label-text {
    margin-top: 0px;
        margin-bottom: 4px;
   }
    .price-container {
        display: flex;
        padding: 8.5px 10px;
        border: 1px solid #578B91;
        border-radius: 4px;
        margin-top: 15px;
        background: #F9FAFB;
    }

    .price-container .saving-wrap {text-align: end;margin-left: auto;}

    .price-container .price-wrap .title {
        font-family: Roboto;
        font-weight: 400;
        font-style: Regular;
        font-size: 13px;
        leading-trim: NONE;
        line-height: 19.5px;
        letter-spacing: 0%;
        color: #305456;
        margin: 0px;
        margin-bottom: 10px;
    }

    .price-container .saving-wrap .title {
        font-family: Roboto;
        font-weight: 600;
        font-style: SemiBold;
        font-size: 14px;
        leading-trim: NONE;
        line-height: 21px;
        letter-spacing: 0%;
        text-align: right;
        color: #305456;
        margin: 0px;
        margin-bottom: 7px;
    }

    .price-container .price-wrap .price-wrap-in span.skio-card__price-now {
        font-family: Roboto;
    font-weight: 700;
    font-style: Bold;
    font-size: 28px;
    leading-trim: NONE;
    line-height: 28px;
    letter-spacing: 0%;
    color:#2B2B2B;
    }

    .price-container .price-wrap .price-wrap-in span.skio-card__price-was {
        font-family: Roboto;
        font-weight: 600;
        font-style: SemiBold;
        font-size: 18px;
        leading-trim: NONE;
        line-height: 28.8px;
        letter-spacing: 0%;
        text-align: right;
        text-decoration: line-through;
        color: #717171;
        vertical-align: top;
        margin-right:10px;
    }

    .price-container .saving-wrap .saving-amount {
        margin: 0px;
        font-family: Roboto;
        font-weight: 600;
        font-style: SemiBold;
        font-size: 14px;
        leading-trim: NONE;
        line-height: 21px;
        letter-spacing: 0%;
        text-align: right;
        color: #305456;
        display: inline;
        margin-right: 10px;
    }

    .price-container .saving-wrap .saving-percent {
        margin: 0px;
        font-family: Roboto;
        font-weight: 700;
        font-style: Bold;
        font-size: 14px;
        leading-trim: NONE;
        line-height: 21px;
        letter-spacing: 0%;
        color: #305456;
        background: #C9E7E5;
        display: inline-block;
        padding: 5px 10px;
        border-radius: 6px;
    }

    .wrap-message-before {

        width: calc(100% - 59px);
        display: flex;
    }

    .wrap-message-before .open-modal-btn {
      display: block;
      width: 100%;
      text-align: center;
      text-decoration: none;
      cursor: pointer;
      color: #62908E;
      font-family: Roboto, sans-serif;
      font-size: 14px;
      font-weight: 700;
      line-height: 1.3;
      padding: 12px 16px;
      border: 1px solid #62908E;
      border-radius: 4px;
      background: #fff;
    }

    .wrap-message-before .open-modal-btn b {
      font-weight: 900;
    }

   .swym-proxy-button {
      margin-top: 12px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      border: 1px solid #305456;
      border-radius: 4px;
      background: #fff;
      color: #305456;
      padding: 14px 18px;
      cursor: pointer;
      font-size: 24px;
      font-family: Roboto, sans-serif;
      font-weight: 900;
      letter-spacing: 0.5px;
    }

    .swym-proxy-button-text {
      font-size: 24px;
      font-family: Roboto, sans-serif;
      font-weight: 900;
      letter-spacing: 0.5px;
    }

    .swym-proxy-button-icon {
      width: 20px;
      height: 20px;
      flex-shrink: 0;
    }

    .swym-proxy-button.atw-button-added svg{

    }

    .swym-proxy-button.atw-button-added svg path{
      fill:#334848;
      strock:#334848;
    }

    .swym-proxy-button.atw-button-added .swym-proxy-button-text{
      color: #334848;
    }


    .swym-proxy-button svg path{
        transition:all 300ms;
    }

    .swym-proxy-button .swym-proxy-button-text{
      transition:all 300ms;
    }

    .swym-proxy-button:hover svg path{
      scale:1.01;
    }

    .swym-proxy-button:hover .swym-proxy-button-text{
      scale:1.01;
    }


      .d-flex-wrap-w-m {
    display: flex;
    margin-top: 16px;
        gap: 10px;
}

.wrap-message-before .open-modal-btn {
    background: linear-gradient(180deg, #b8860b 0%, #cd853f 50%, #daa520 100%);
    border: none;
    border-radius: 4px;
    padding: 9px 24px;
    color: white;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    position: relative;
    overflow: hidden;
    text-decoration: none;
    text-align: center;
    letter-spacing: 0px;
    justify-content: center;
    align-items: center;
    border: 3px solid #000;
    line-height: 1.3;
    flex-direction: column;
    font-size: 17px;
    display: flex;
    width: 100%;
    font-family: Roboto;
    font-weight: 400;
    font-style: Regular;
    font-size: 15px;
    leading-trim: NONE;
    line-height: Static/Body Large/Line Height;
    letter-spacing: 0%;
}

button.swym-proxy-button {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    justify-content: center;
    gap: 5px;
    padding:0px;
    border:none;
    width:59px;
        margin-top: 0px;
}

button.swym-proxy-button svg.swym-proxy-button-icon {
    width: 24px;
    height: 24px;
}

button.swym-proxy-button span.swym-proxy-button-text {
    font-size: 10px;
    line-height: 10px;
    color: #334848;
    font-family: Roboto, sans-serif;
    font-weight: 900;
    letter-spacing: 0.5px;
    text-transform: uppercase;
}
.gaurantee-Back-tag  button.model-close-btn::before {
        content: none;
}
    .skio-card__header.one-time .skio-card__price {
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .atc-price-display {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 20px;
      font-weight: 500;
    }
    .atc-save-btn {
        font-size: 12px;
        font-weight: 300;
        letter-spacing: 0.3px;
    }
          .gaurantee-Back-tag .model-main-wrap {
              border-radius: 12px;
              position: relative;
              padding-top: 12px;
          }
          .gaurantee-Back-tag .model-main-wrap::before {
              content: "";
              position: absolute;
              height: 12px;
              width: 100%;
              background-image:  linear-gradient(90deg, #CD853F 100%, #DAA520 50%, #8D673D 0%);
              left: 0;
              top: 0px;
              z-index: 15;
              border-radius: 12px 12px 0px 0px;
          }
.gaurantee-Back-tag button.model-close-btn {
    position: sticky;
    right: 12px !important;
    top: 23px !important;
    height: 17px !important;
    background: transparent !important;
    font-weight: 400;
}  
@media (min-width:768px){
  .gaurantee-Back-tag button.model-close-btn {
    display:none;
  }
  .gaurantee-Back-tag button.model-close-btn.model-close-btn-mob {
    display:block
  } 
  .gaurantee-Back-tag button.model-close-btn.model-close-btn-mob {
      display: block;
      color: #000;
      position: relative !important;
      top: 0px !important;
      padding: 16px 0px;
  }
}    
  @media (max-width:767px) {
  .model-wrap.gaurantee-Back-tag .model-main-wrap .content-wrap {
    padding:20px 30px 0px;
  }
  .model-wrap.gaurantee-Back-tag button.end-close-btn {
                   margin-bottom: 35px;
  }
  button.model-close-btn-mob {
    display:block;
    position: absolute !important;
    top: 0px !important;
    right: 10px !important;
    background: none !important;
    border: none !important;
    font-size: 30px !important;
    z-index: 122;
    box-shadow: none !important;
    width: fit-content !important;
    padding: 0px !important;
    height:unset;
}
  button.model-close-btn.desk {
      display: none;
  }
  button.model-close-btn-mob {
      position: absolute;
      top: 10px;
      right: 0;
      background: none;
      border: none;
  }
    .skio-card { padding:0px 13px 19px }
    .skio-card__title { font-size:18px; }
    .skio-card__price { font-size:20px; }
    .skio-card__price-was { font-size:16px; }
    .skio-frequency-group { gap:8px; }
    .skio-frequency-radio { font-size:15px; }
    .skio-benefits.skio-benefits--plain li { font-size:14px; }
    .skio-onetime-copy { font-size:14px; }
    .skio-atc { font-size:16px; padding:16px 20px; }

    .model-main-wrap { max-width:100%; border-radius:0; padding:0; }

    button.model-close-btn::before {
      font-size:16px;
      text-transform:uppercase;
      position:relative;
      top:1px;
    }

    button.model-close-btn {
      position: sticky;
      top: 0px;
      background: #fff !important;
      left:unset;
      right:unset;
      height:50px;
      box-shadow:0 3px 4px rgba(0,0,0,.25);
      width:100%;
      padding:10px;
      margin-left:auto;
      color:#000;
      font-size:20px;
      border:none;
      background:none;
      display:flex;
      align-items:center;
      justify-content:center;
      gap:10px;
      font-family:var(--typeBasePrimary),var(--typeBaseFallback);
      letter-spacing:var(--typeBaseSpacing);
      line-height:var(--typeBaseLineHeight);
      font-weight:bold;
    }
      .wrap-message-before .open-modal-btn {
          padding: 5px 24px;
      }

    .model-wrap .model-main-wrap .content-wrap { padding:40px 30px 30px; }
    button.end-close-btn { font-size:13px; width:50%; padding:13px 33px;margin-bottom: 50px;}
    .getsunmedpdpsusbsavesubsinfocontent .model-main-wrap .content-wrap p { font-size:15px; }

    .getsunmedpdpsusbsavesubsinfocontent .model-main-wrap {
      padding:0 30px 100px;
        
    }
   /* Parent overlay — add flexbox centering */
    .getsunmedpdpsusbsavesubsinfocontent.model-wrap {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0px; /* prevents modal touching screen edges on small screens */
    }

    /* Modal — remove absolute positioning and top/left entirely */
    .getsunmedpdpsusbsavesubsinfocontent .model-main-wrap {
        position: relative;
        left: auto;
        top: auto;
        transform: scale(0.95);
        background: #fff;
        height: fit-content;
        max-width: 550px;
        width: 100%;
        opacity: 0;
        transition: opacity .25s ease, transform .25s ease;
        overflow-y: auto;
        margin-top: 0;
        -ms-scroll-chaining: none;
        overscroll-behavior: none;
        padding: 0px 0px 0px;
        border-radius: 0px;
        max-height: 88vh;
    }

    /* Open state — only scale and opacity change, no position shift */
    .model-wrap.is-open.getsunmedpdpsusbsavesubsinfocontent .model-main-wrap {
        transform: scale(1);
        opacity: 1;
    }
    .getsunmedpdpsusbsavesubsinfocontent.model-wrap .model-main-wrap .content-wrap {
      padding:10px 10px 10px;
    }

    .outer-delivey-text > svg {
      position: relative;
      top: 4px;
    }

    span.outer-delivey-text {
      text-align: start;
      position: relative;
      top: -2px;
    }
      .gaurantee-Back-tag button.model-close-btn {
        display:none;
      }
      .gaurantee-Back-tag  button.model-close-btn.model-close-btn-mob {
          display: block;
          top: 7px !important;
      }
  }
  /* Desktop button adjustments */
@media (min-width: 768px) {

  /* increase space between buttons */
  .d-flex-wrap-w-m{
    gap:16px;
  }

  /* make "See this before you buy" 20% shorter */
  .wrap-message-before{
    width: calc(100% - 75px);
  }

  /* make shortlist button slightly wider */
  button.swym-proxy-button{
    width:75px;
  }
}

.discount-announcement--content {
  display: flex;
  gap: 5px;
  justify-content: center;
  font-weight: 500;
  color: #f8f8f8ff;
  background: linear-gradient(180deg, #b8860b 0%, #cd853f 50%, #daa520 100%);
  border: solid #8d5c2d 1px;
  border-radius: 7px;
  margin: 0 0 10px auto;
  padding: 2px 10px;
  width: fit-content;

  p {
    margin: 0px;
  }
}

.discount-announcement--content-mobile {
  display: flex;
  justify-content: center;
  font-weight: 500;
  font-size: 13px;
  color: #f8f8f8ff;
  background: linear-gradient(180deg, #b8860b 0%, #cd853f 50%, #daa520 100%);
  border: solid #8d5c2d 1px;
  border-radius: 7px;
  margin: 10px 0 0;
  padding: 2px 10px;
  p {
    margin: 0px;
  }
}
.discount-announcement--check {
    opacity: 0;
    animation: checkMark 3s ease-out 4.5s forwards;
    align-self: center;
}
@keyframes checkMark {
    0% {
        -webkit-transform: scale(0);
        transform: scale(0);
    }
    5%, 20%, 90%, 100% {
        opacity: 100; 
        -webkit-transform: scale(1) rotate(0deg);
        transform: scale(1) rotate(0deg);
    }
    10% {
        -webkit-transform: scale(1.2) rotate(20deg);
        transform: scale(1.2) rotate(20deg);
    }
    15% {
        -webkit-transform: scale(1.2) rotate(-20deg);
        transform: scale(1.2) rotate(-20deg);
    }
}

.discount-announcement--arrow {
  display: flex;
  justify-content: center;
  margin: 0 auto 0 auto;
  width: fit-content;
}

.discount-announcement--content2 {
  display: flex;
  justify-content: center;
  font-weight: 500;
  font-size: 13px;
  margin: 5px auto 0 auto;
  padding: 2px 10px;
  width: fit-content;
  p {
    margin: 0;
    text-align: center;
    hlight {
      padding: 5px;
      background: yellow;
    }
  }
}
  
.hide { display:none; }
  @media (max-width: 767px) {
      .model-wrap.gaurantee-Back-tag .model-main-wrap {
        width: 94%;
      }
  }
`;

export class SkioPlanPickerComponent extends LitElement {
  static properties = {
    product: { type: Object },
    productHandle: { type: String },
    key: { type: String },
    formId: { type: String },
    needsFormId: { type: Boolean },
    subscriptionFirst: { type: Boolean },
    startSubscription: { type: Boolean },
    discountFormat: { type: String },
    currency: { type: String },
    language: { type: String },
    moneyFormatter: {},
    externalPriceSelector: { type: String },
    externalPriceSelectorWithCurrency: { type: String },
    externalSaveSelector: { type: String },
    selectedVariant: { type: Object },
    skioSellingPlanGroups: {},
    availableSellingPlanGroups: {},
    selectedSellingPlanGroup: {},
    selectedSellingPlan: {},
    defaultFrequency: {},
    useVariantInputClickEvents: { type: Boolean },
    variantInputSelector: {}
  };

  static styles = skioStyles;

  constructor() {
    super();
    this.product = null;
    this.selectedVariant = null;
    this.productHandle = null;

    this.purchaseOption = 'onetime';
    this.key = null;

    this.formId = null;
    this.needsFormId = false;

    this.skioSellingPlanGroups = [];
    this.availableSellingPlanGroups = [];

    this.selectedSellingPlanGroup = null;
    this.selectedSellingPlan = null;

    this.startSubscription = false;
    this.subscriptionFirst = false;

    this.discountFormat = 'percent';
    this.externalPriceSelector = '[skio-external-price]';
    this.externalPriceSelectorWithCurrency = '[skio-external-price-with-currency]';
    this.externalSaveSelector = '[skio-external-save]';

    this.currency = Shopify?.currency?.active || 'USD';
    this.language = 'en-US';
    this.moneyFormatter = new Intl.NumberFormat(this.language, {
      style: 'currency',
      currency: this.currency,
      trailingZeroDisplay: "stripIfInteger"
    });

    this.defaultFrequency = null;
    this.useVariantInputClickEvents = null;
    this.variantInputSelector = null;

    this.skioUiInitialized = false;

    this.modalHandlersBound = false;
    this.modalStackCount = 0;
    this.BASE_Z_INDEX = 10000;
    this.Z_INCREMENT = 1001;
    this.onModalRootClick = null;
    this.onModalRootCloseClick = null;

    this.swymSyncInitialized = false;
    this.swymButtonObserver = null;
    this.swymDocumentObserver = null;

    this.modalMap = {
      'getsunmedpdpsusbsavesubsinfocontent': 'getsunmedpdpsusbsavesubsinfocontent',
      'gaurantee-Back-tag': 'gaurantee-Back-tag'
    };
  }

  connectedCallback() {
    super.connectedCallback();

    if (!this.product && this.productHandle) this.fetchProduct(this.productHandle);

    if (this.needsFormId && this.formId == null) {
      const forms = document.querySelectorAll('form[action="/cart/add"]');
      if (forms.length) {
        let form;
        forms.forEach((el) => {
          if (el.hasAttribute('skio-key') && el.getAttribute('skio-key') == this.key) {
            form = el;
          }
        });
        if (!form) form = forms[0];
        this.formId = form.id;
        this.requestUpdate();
      }
    }

    const skio = this;
    document.addEventListener('variantChanged', function (e) {
      const variantId = e?.detail?.variantId;
      if (!variantId || !skio.product?.variants) return;
      const variant = skio.product.variants.find((x) => String(x.id) === String(variantId));
      if (variant) skio.selectedVariant = variant;
      skio.requestUpdate();
    });

    if (this.useVariantInputClickEvents) {
      document.addEventListener('load', skio.addVariantClickEventListeners);
    }
  }

  firstUpdated() {
    this.bindModalHandlers();
    this.initSwymButtonSync();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.unbindModalHandlers();

    if (this.swymButtonObserver) {
      this.swymButtonObserver.disconnect();
      this.swymButtonObserver = null;
    }

    if (this.swymDocumentObserver) {
      this.swymDocumentObserver.disconnect();
      this.swymDocumentObserver = null;
    }
  }

  bindModalHandlers() {
    if (this.modalHandlersBound) return;
    this.modalHandlersBound = true;

    this.onModalRootClick = (e) => {
      const trigger = e.target?.closest?.('.open-modal-btn, .scrolling-text');
      if (!trigger) return;

      const triggerId = trigger.id;
      const targetClass = this.modalMap?.[triggerId] || triggerId;
      const modal = this.renderRoot.querySelector(`.model-wrap.${CSS.escape(targetClass)}`);
      if (!modal) return;

      e.preventDefault();
      this.openModal(modal);
      var allWidgetUiElm = document.querySelectorAll('access-widget-ui');
      allWidgetUiElm.forEach((a) => {
        a.style.setProperty('all', 'inherit', 'important');
        a.style.setProperty('position', 'relative', 'important');
        a.style.setProperty('z-index', '1', 'important');
      });
    };

    this.onModalRootCloseClick = (e) => {
      const btn = e.target?.closest?.('.model-close-wrap, .model-close-btn, .end-close-btn');
      if (!btn) return;

      const modal = btn.closest('.model-wrap');
      if (!modal) return;

      e.preventDefault();
      this.closeModal(modal);
      document.querySelector('#shopify-section-header').classList.remove('go-be');
      var omniAdvisorChatWidget = document.querySelector('#omni-advisor-chat-widget')
      omniAdvisorChatWidget.classList.remove('hide');
      var allWidgetUiElm = document.querySelectorAll('access-widget-ui');
      allWidgetUiElm.forEach((a) => {
        // Remove the host inline style
        a.removeAttribute('style');

        // Remove the injected <style> from shadow root
        if (a.shadowRoot) {
          const injectedStyle = a.shadowRoot.querySelector('style[data-modal-override="true"]');
          if (injectedStyle) {
            injectedStyle.remove();
          }
        }
      });
    };

    this.renderRoot.addEventListener('click', this.onModalRootClick);
    this.renderRoot.addEventListener('click', this.onModalRootCloseClick);
  }

  unbindModalHandlers() {
    if (!this.modalHandlersBound) return;
    this.modalHandlersBound = false;

    if (this.onModalRootClick) {
      this.renderRoot.removeEventListener('click', this.onModalRootClick);
    }
    if (this.onModalRootCloseClick) {
      this.renderRoot.removeEventListener('click', this.onModalRootCloseClick);
    }

    this.onModalRootClick = null;
    this.onModalRootCloseClick = null;
  }

  syncSwymButtonState() {
    const proxyBtn = this.renderRoot?.querySelector('.swym-proxy-button');
    const realBtn = document.querySelector('#swym-atw-pdp-button');

    if (!proxyBtn) return;

    if (!realBtn) {
      proxyBtn.classList.remove('atw-button-added');
      return;
    }

    proxyBtn.classList.toggle(
      'atw-button-added',
      realBtn.classList.contains('atw-button-added')
    );
  }

  initSwymButtonSync() {
    if (this.swymSyncInitialized) return;
    this.swymSyncInitialized = true;

    const attachObserverToRealButton = () => {
      const realBtn = document.querySelector('#swym-atw-pdp-button');
      if (!realBtn) return false;

      this.syncSwymButtonState();

      if (this.swymButtonObserver) {
        this.swymButtonObserver.disconnect();
      }

      this.swymButtonObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            this.syncSwymButtonState();
          }
        }
      });

      this.swymButtonObserver.observe(realBtn, {
        attributes: true,
        attributeFilter: ['class']
      });

      return true;
    };

    if (!attachObserverToRealButton()) {
      this.swymDocumentObserver = new MutationObserver(() => {
        if (attachObserverToRealButton()) {
          if (this.swymDocumentObserver) {
            this.swymDocumentObserver.disconnect();
            this.swymDocumentObserver = null;
          }
        }
      });

      this.swymDocumentObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  validateShipToState() {
    const stateInput = document.querySelector('#shipToStateInputContainer input');
    if (!stateInput) return true;

    const value = stateInput.value?.trim();
    if (value) return true;

    const container = document.querySelector('#shipToStateInputContainer') || stateInput;

    container.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

    setTimeout(() => {
      stateInput.focus();

      stateInput.dispatchEvent(new Event('input', { bubbles: true }));
      stateInput.dispatchEvent(new Event('change', { bubbles: true }));
      stateInput.dispatchEvent(new Event('blur', { bubbles: true }));

      const form = stateInput.form || stateInput.closest('form');
      if (form && typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      }
    }, 300);

    return false;
  }

  _getHideWhySubscribe() {
    if (typeof window !== 'undefined' && window.__HIDE_WHY_SUBSCRIBE__ !== undefined) {
      return window.__HIDE_WHY_SUBSCRIBE__;
    }
    try {
      return null;
    } catch (e) {
      return false;
    }
  }

  _getWhySubscribeHtml() {
    const mf = (window.__WHY_SUBSCRIBE_TEXT__ || '').toString().trim();
    if (mf) return mf;
    return (window.__WHY_SUBSCRIBE_DEFAULT_HTML__ || '').toString().trim();
  }

  _escapeHtml(str) {
    return String(str)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  _productPhrase() {
    const title = (this.product?.title || '').trim();
    if (!title) return '';
    // plural titles ("Gummies", "Capsules") drop the article
    return /s$/i.test(title) ? title : `this ${title}`;
  }

  _mountWhyHtmlIntoModal() {
    const mount = this.renderRoot.querySelector('[data-why-html-mount]');
    if (!mount) return;

    const raw = (this._getWhySubscribeHtml() || '').toString().trim();
    if (!raw) {
      mount.innerHTML = '';
      mount.style.display = 'none';
      return;
    }

    mount.style.display = '';

    const looksLikeHtml = /<\/?[a-z][\s\S]*>/i.test(raw);
    if (looksLikeHtml) {
      mount.innerHTML = raw;
      return;
    }

    const parts = raw
      .split(/\r?\n\s*\r?\n|\r?\n/g)
      .map((s) => s.trim())
      .filter(Boolean);

    mount.innerHTML = parts.map((t) => `<p>${this._escapeHtml(t)}</p>`).join('');
  }

  openModal(modal) {
    if (!modal) return;

    this.modalStackCount++;
    const currentZ = this.BASE_Z_INDEX + this.modalStackCount * this.Z_INCREMENT;

    modal.classList.add('is-open');
    modal.style.zIndex = String(currentZ);

    this._mountWhyHtmlIntoModal();

    document.documentElement.style.overflow = 'hidden';

    const mars = document.querySelector('#marsello-widget-root');
    // if (mars) mars.style.setProperty('z-index', '999999999', 'important');

    const pc = document.querySelector('#PageContainer');
    if (pc) {
      pc.style.position = 'relative';
      // pc.style.zIndex = String(999999999999999);
    }

    const atc = document.querySelector('.btn-add-to-card-wrap');
    // if (atc) atc.style.setProperty('z-index', '10', 'important');
  }

  closeModal(modal) {
    if (!modal) return;

    modal.classList.remove('is-open');
    // modal.style.zIndex = '';

    if (this.modalStackCount > 0) this.modalStackCount--;

    const anyOpen = this.renderRoot.querySelector('.model-wrap.is-open');
    if (!anyOpen) {
      const mars = document.querySelector('#marsello-widget-root');
      if (mars) mars.removeAttribute('style');

      const pc = document.querySelector('#PageContainer');
      if (pc) pc.removeAttribute('style');

      setTimeout(() => {
        const stillOpen = !!this.renderRoot.querySelector('.model-wrap.is-open');
        if (!stillOpen) {
          document.documentElement.style.overflow = '';
          this.modalStackCount = 0;
        }
      }, 260);

      const atc = document.querySelector('.btn-add-to-card-wrap');
      if (atc) atc.removeAttribute('style');
    }
  }

  openModalByTriggerId(triggerId) {
    const targetClass = this.modalMap?.[triggerId] || triggerId;
    const modal = this.renderRoot.querySelector(`.model-wrap.${CSS.escape(targetClass)}`);
    if (!modal) return;
    this.openModal(modal);
    document.querySelector('#shopify-section-header').classList.add('go-be');
    var omniAdvisorChatWidget = document.querySelector('#omni-advisor-chat-widget')
    omniAdvisorChatWidget.classList.add('hide');
    var allWidgetUiElm = document.querySelectorAll('access-widget-ui');
    allWidgetUiElm.forEach((a) => {
      // Set styles on the host element itself
      a.style.setProperty('all', 'inherit', 'important');
      a.style.setProperty('position', 'relative', 'important');
      a.style.setProperty('z-index', '1', 'important');

      // Inject <style> into the open shadow root
      if (a.shadowRoot) {
        const style = document.createElement('style');
        style.setAttribute('data-modal-override', 'true'); // ID for later removal
        style.textContent = `
          :host {
            all: inherit !important;
            position: relative !important;
            z-index: 1 !important;
          }
          /* Add any inner shadow DOM styles here */
          * {
            z-index: 1 !important;
          }
        `;
        a.shadowRoot.appendChild(style);
      }
    });
  }

  async submitAddToCart(items) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items })
    });

    if (!response.ok) {
      let errorMessage = 'Failed to add to cart';
      try {
        const errorData = await response.json();
        errorMessage = errorData?.description || errorData?.message || errorMessage;
      } catch (e) {}
      throw new Error(errorMessage);
    }

    return response.json();
  }

  async openCartDrawerOrRefresh() {
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));

      const cartDrawerTriggers = [
        '[data-drawer-open-btn]',
        '[data-cart-toggle]',
        '.js-drawer-open-cart',
        '.site-header__cart',
        '.header-cart',
        '[href="/cart"]'
      ];

      for (const selector of cartDrawerTriggers) {
        const el = document.querySelector(selector);
        if (el && selector !== '[href="/cart"]') {
          el.click();
          return;
        }
      }
    } catch (e) {
      console.warn('Cart UI refresh failed', e);
    }
  }

  async submitSubscription() {
    if (!this.validateShipToState()) return;

    try {
      const variantId = this.selectedVariant?.id;
      if (!variantId) return;

      const group = this.availableSellingPlanGroups?.[0] || null;
      if (!group) throw new Error('No subscription group found');

      const sellingPlan = group.selected_selling_plan || group.selling_plans?.[0] || null;
      if (!sellingPlan?.id) throw new Error('No selling plan selected');

      group.selected_selling_plan = sellingPlan;
      this.selectedSellingPlanGroup = group;
      this.selectedSellingPlan = sellingPlan;
      this.purchaseOption = 'subscription';

      this.updateExternalPrice();
      this.requestUpdate();

      await this.submitAddToCart([
        {
          id: variantId,
          quantity: 1,
          selling_plan: sellingPlan.id,
          properties: {
            Discount: this.discount(sellingPlan).percent
          }
        }
      ]);

      await this.openCartDrawerOrRefresh();
    } catch (error) {
      console.error('Subscription add failed:', error);
      alert(error.message || 'Unable to add subscription to cart');
    }
  }

  async submitOnetime() {
    if (!this.validateShipToState()) return;

    try {
      const variantId = this.selectedVariant?.id;
      if (!variantId) return;

      this.selectedSellingPlanGroup = null;
      this.selectedSellingPlan = null;
      this.purchaseOption = 'onetime';

      this.updateExternalPrice();
      this.requestUpdate();

      await this.submitAddToCart([
        {
          id: variantId,
          quantity: 1
        }
      ]);

      await this.openCartDrawerOrRefresh();
    } catch (error) {
      console.error('One-time add failed:', error);
      alert(error.message || 'Unable to add item to cart');
    }
  }

  getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
          c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
      }
      }
      return "";
  }
  
  render() {
    if (!this.product || !this.selectedVariant || this.skioSellingPlanGroups.length == 0) return;

    const hideWhySubscribe = this._getHideWhySubscribe();
    const rawWhy = (this._getWhySubscribeHtml() || '').toString().trim();
    const hasWhy = rawWhy.length > 0;

    const defaultWhySubscribeLines = [
      `Meditation doesn’t transform us in a day — it takes about 8 weeks of consistent practice before the real benefits appear.`,
      `The same’s true for ${this.product?.title || ''} — our bodies need time to respond.`,
      `We’ve worked with thousands who take ${this.product?.title || ''}.`,
      `Those who take it for a few months see better results — much better results than those who try it for a few weeks.`
    ].filter(Boolean);

    const whySubscribeContent = hasWhy
      ? html`<div class="content-wrap" data-why-html-mount></div>`
      : html`
          <div class="content-wrap">
            ${defaultWhySubscribeLines.map((t) => html`<p>${t}</p>`)}
          </div>
        `;

    const subscriptionGroup = this.availableSellingPlanGroups?.[0] || null;
    const plans = subscriptionGroup?.selling_plans || [];
    const selectedPlan = subscriptionGroup?.selected_selling_plan || null;

    const oneTimePriceRaw = this.selectedVariant.price;
    const subscriptionPriceRaw = selectedPlan ? this.price(selectedPlan, false) : this.selectedVariant.price;

    const oneTimePrice = this.moneyFormatter.format(oneTimePriceRaw / 100);
    const subscriptionPrice = this.moneyFormatter.format(subscriptionPriceRaw / 100);
    const savingAmount = this.money(oneTimePriceRaw - subscriptionPriceRaw);
	const savingAmountCompare = this.money(this.selectedVariant.compare_at_price - this.selectedVariant.price);

	const oneTimePriceWDiscount = this.selectedVariant.metafields?.auto_discounted_price ? html`${this.moneyFormatter.format(this.selectedVariant.metafields.auto_discounted_price / 100)} <s>${oneTimePrice}</s>` : oneTimePrice;
		
    const subscribeDiscountText = this.discountFormat == 'percent'
      ? this.discount(selectedPlan).percent
      : this.money(this.discount(selectedPlan).amount);

    const discountCode = getCookie('discount_code');

    const checkSvg = html`
      <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8.5" cy="9.05" r="8.5" fill="#305456"></circle>
        <path d="M4.5 9.05L7 12.05L12.5 7.05" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>
    `;

    return html`<fieldset class="skio-plan-picker skio-cards skio-plan-picker-${this.key}">
      ${this.formId != null ? html`<input form="${this.formId}" name="selling_plan" type="hidden" value="${this.selectedSellingPlan != null ? this.selectedSellingPlan?.id : ''}">` : ''}
      ${this.formId != null ? html`<input form="${this.formId}" name="properties[Discount]" type="hidden" value="${this.selectedSellingPlan != null ? this.discount(this.selectedSellingPlan).percent : ''}" ?disabled="${this.selectedSellingPlan == null}">` : ''}

      ${this.availableSellingPlanGroups?.length === 0 ? html`

        <!-- NO SUBSCRIPTION for this variant — show full one-time card -->
        <div class="skio-card">
          <div class="discount-announcement--content ${discountCode == '' ? ' hide' : ''}">
            <p>Discount ${discountCode} activated. Just add to the cart to see the discounted price.</p>
            <p class="discount-announcement--check">✓</p>
          </div>
          <div class="discount-announcement--content ${this.selectedVariant.metafields?.discount_pdp_copy ? '' : ' hide'}">
          <p>${this.selectedVariant.metafields?.discount_pdp_copy} - ${this.selectedVariant.metafields?.discount_percentage * 100}% off applied</p>
        </div>
          <div class="skio-card__header one-time">
            <div class="skio-radio__container">
              <input
                id="skio-one-time-${this.key}"
                class="skio-native-radio"
                name="skio-purchase-option-${this.key}"
                type="radio"
                value="onetime"
                .checked=${true}
                @click=${(e) => e.stopPropagation()}
              />
              <span class="skio-radio-ui" aria-hidden="true"></span>
            </div>
            <label class="skio-card__title" for="skio-one-time-${this.key}">One time purchase</label>
            <div class="skio-card__price">
              <span class="skio-card__price-now">${this.selectedVariant.metafields?.auto_discounted_price ? this.moneyFormatter.format(this.selectedVariant.metafields.auto_discounted_price / 100) : this.moneyFormatter.format(this.selectedVariant.price / 100)}</span>
              ${this.selectedVariant.compare_at_price ? html`<span class="skio-card__price-was">${this.moneyFormatter.format(this.selectedVariant.compare_at_price / 100)}</span>` : (this.selectedVariant.metafields?.auto_discounted_price ? html`<span class="skio-card__price-was">this.moneyFormatter.format(this.selectedVariant.price / 100)<span>` : '')}
            </div>
          </div>

          <div class="skio-card__body">
            <div class="d-flex-wrap-w-m">
              <div class="wrap-message-before">
                <span
                  class="open-modal-btn"
                  id="gaurantee-Back-tag"
                  @click=${(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.openModalByTriggerId('gaurantee-Back-tag');
                  }}
                >
                  SEE THIS <br>
                  <b>BEFORE YOU BUY</b>
                </span>

                <div class="model-wrap gaurantee-Back-tag">
                  <div class="model-close-wrap" style="display: none;"></div>
                  <div class="model-main-wrap">
                    <button class="model-close-btn">CLOSE X</button>
                    <button class="model-close-btn model-close-btn-mob">×</button>
                    <div class="content-wrap">

                          <p>The only way to get someone to buy again is by making something that <b>actually works.</b></p>
                          <p>Broad Spectrum Allergy Aid CBD Pet Chews works.</p>
                          <p>And if I'm wrong, I'll personally send you full refund.</p>
                          <button class="end-close-btn">CONTINUE</button>
                      </div>
                  </div>
                </div>
              </div>

              <button
                type="button"
                class="swym-proxy-button"
                @click=${(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  const realSwymButton = document.querySelector('#swym-atw-pdp-button');
                  if (realSwymButton) {
                    realSwymButton.click();
                    setTimeout(() => this.syncSwymButtonState(), 50);
                  }
                }}
              >
                <svg class="swym-proxy-button-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                  <path d="M5 6.2C5 5.07989 5 4.51984 5.21799 4.09202C5.40973 3.71569 5.71569 3.40973 6.09202 3.21799C6.51984 3 7.07989 3 8.2 3H15.8C16.9201 3 17.4802 3 17.908 3.21799C18.2843 3.40973 18.5903 3.71569 18.782 4.09202C19 4.51984 19 5.07989 19 6.2V21L12 16L5 21V6.2Z" stroke="#334848" stroke-width="1.75" fill="none" stroke-linejoin="round"></path>
                </svg>
                <span class="swym-proxy-button-text">Shortlist</span>
              </button>
            </div>

            <button
              type="button"
              class="skio-atc skio-atc--subscription"
              @click=${async (e) => {
                e.preventDefault();
                e.stopPropagation();
                await this.submitOnetime();
              }}
            >
              <div>ADD TO CART</div><div class="atc-price-display">${savingAmountCompare ? html`<span class="atc-save-btn">(SAVE ${savingAmountCompare})</span>` : ``}<span>${oneTimePrice}</span></div>
            </button>
          </div>
        </div>

      ` : html`

        <!-- SUBSCRIPTION EXISTS for this variant — show original subscription + one-time cards -->
        <!-- ==================== PASTE YOUR EXISTING SUBSCRIPTION CARD HERE ==================== -->
         <div class="skio-card">
          <div class="skio-card__header">
            <div class="skio-radio__container" aria-hidden="true">
              <input class="skio-native-radio" type="radio" disabled tabindex="-1" />
              <span class="skio-radio-ui" aria-hidden="true"></span>
            </div>

            <div class="skio-card__title">
              Subscribe <small style="font-size: 18px;">&</small> Save ${subscribeDiscountText}
            </div>
          </div>

          <div class="skio-card__body is-open">
            <ul class="skio-benefits skio-benefits--plain">
              <li>${checkSvg}Lock in your discount for life</li>

              ${!hideWhySubscribe ? html`
                <li>
                  ${checkSvg}
                  <span
                    class="open-modal-btn"
                    id="getsunmedpdpsusbsavesubsinfocontent"
                    @click=${(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      this.openModalByTriggerId('getsunmedpdpsusbsavesubsinfocontent');
                    }}
                  >Why subscribe?</span>
                  <span>←</span>
                  <span>Click</span>
                </li>
              ` : html``}

              <li>${checkSvg}30-day money back guarantee</li>
            </ul>

            <div class="skio-frequency-group custom-group">
              <p class="label-text">Delivery frequency:</p>
              <div class="skio-frequency-group-inner-wrap">
                ${plans.map((plan) => html`
                  <label class="skio-frequency-radio">
                    <input
                      type="radio"
                      name="skio-frequency-${this.key}"
                      value="${plan.id}"
                      ?checked=${selectedPlan?.id == plan.id}
                      @change=${(e) => subscriptionGroup && this.selectSellingPlan(e.target, subscriptionGroup)}
                    />
                    <span class="skio-frequency-label">
                      ${plan.name === 'Every 1 Month'
                        ? '30 days'
                        : plan.name === 'Every 2 Months'
                          ? '60 days'
                          : plan.name === 'Every 3 Months'
                            ? '90 days'
                            : plan.name}
                    </span>
                  </label>
                `)}
              </div>
            </div>

            <div class="price-container">
              <div class="price-wrap">
                <p class="title">Subscription price</p>
                <div class="price-wrap-in">
                  <span class="skio-card__price-was">${oneTimePrice}</span>
                  <span class="skio-card__price-now">${subscriptionPrice}</span>
                </div>
              </div>

              <div class="saving-wrap">
                <p class="title">Your saving:</p>
                <div class="saving-wrap-in">
                  <p class="saving-amount">${savingAmount}</p>
                  <p class="saving-percent">${subscribeDiscountText}</p>
                </div>
              </div>
            </div>

                      <div class="d-flex-wrap-w-m">
              <div class="wrap-message-before">
                <span
                  class="open-modal-btn"
                  id="gaurantee-Back-tag"
                  @click=${(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.openModalByTriggerId('gaurantee-Back-tag');
                  }}
                >
                  SEE THIS <br>
                  <b>BEFORE YOU BUY</b>
                </span>

                <div class="model-wrap gaurantee-Back-tag">
                <div class="model-close-wrap" style="display: none;"></div>
                <div class="model-main-wrap">
                  <button class="model-close-btn desk">CLOSE X</button>
                    <button class="model-close-btn model-close-btn-mob">×</button>
                  <div class="content-wrap">

                          <p>The only way to get someone to buy again is by making something that <b>actually works.</b></p>
                          <p>Broad Spectrum Allergy Aid CBD Pet Chews works.</p>
                          <p>And if I'm wrong, I'll personally send you full refund.</p>
                      </div>
                  <button class="end-close-btn">CONTINUE</button>
                </div>
              </div>
              </div>

              <button
                type="button"
                class="swym-proxy-button"
                @click=${(e) => {
                  e.preventDefault();
                  e.stopPropagation();

                  const realSwymButton = document.querySelector('#swym-atw-pdp-button');
                  if (realSwymButton) {
                    realSwymButton.click();
                    setTimeout(() => this.syncSwymButtonState(), 50);
                  }
                }}
              >
                <svg class="swym-proxy-button-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                  <path d="M5 6.2C5 5.07989 5 4.51984 5.21799 4.09202C5.40973 3.71569 5.71569 3.40973 6.09202 3.21799C6.51984 3 7.07989 3 8.2 3H15.8C16.9201 3 17.4802 3 17.908 3.21799C18.2843 3.40973 18.5903 3.71569 18.782 4.09202C19 4.51984 19 5.07989 19 6.2V21L12 16L5 21V6.2Z" stroke="#334848" stroke-width="1.75" fill="none" stroke-linejoin="round"></path>
                </svg>
                <span class="swym-proxy-button-text">Shortlist</span>
              </button>
            </div>

            <button
              type="button"
              class="skio-atc skio-atc--subscription"
              @click=${async (e) => {
                e.preventDefault();
                e.stopPropagation();
                await this.submitSubscription();
              }}
            >
              <div>SUBSCRIPTION PRICE</div><div class='atc-price-display'><span class="atc-save-btn">(SAVE ${savingAmount})</span><span>${subscriptionPrice}</span></div>
            </button>
          </div>
        </div>

        <div class="skio-card one-time">
          <div class="skio-card__body is-open">
            <button
              type="button"
              class="skio-atc skio-atc--subscription no-padding"
              @click=${async (e) => {
                e.preventDefault();
                e.stopPropagation();
                await this.submitOnetime();
              }}
            >
				<div>ONE-TIME PURCHASE</div><div class='atc-price-display'>${oneTimePriceWDiscount}</div>
            </button>
			<div class="discount-announcement--arrow${this.selectedVariant.metafields?.discount_pdp_copy || discountCode != '' ? '' : ' hide'}">↑</div>
            <div class="discount-announcement--content2 ${this.selectedVariant.metafields?.discount_pdp_copy ? '' : ' hide'}">
              <p><hlight>${this.selectedVariant.metafields?.discount_pdp_copy} - ${this.selectedVariant.metafields?.discount_percentage * 100}% off applied</hlight></p>
            </div> 
            <div class="discount-announcement--content2 ${discountCode == '' ? ' hide' : ''}">
              <p><hlight>Discount ${discountCode} activated. Just add to the cart to see the discounted price.</hlight></p>
            </div>         
          </div>
        </div>

      `}

      <!-- modals stay outside the conditional — always rendered -->
      <div class="model-wrap getsunmedpdpsusbsavesubsinfocontent">
          <div class="model-close-wrap" style="display: none;"></div>
          <div class="model-main-wrap">
            <button class="model-close-btn">✕</button>
            ${whySubscribeContent}
            <button class="end-close-btn">CONTINUE</button>
          </div>
        </div>

        <style>
          .model-wrap{position:fixed;inset:0;display:block;opacity:0;visibility:hidden;transition:opacity .4s ease-in, visibility .4s ease-in;z-index:999999999999}
          .model-wrap.is-open{opacity:1;visibility:visible}
          .model-close-wrap{position:absolute;inset:0;background:rgba(0,0,0,.5);opacity:0;transition:opacity .4s ease-in;display:none}
          .model-wrap.is-open .model-close-wrap{display:block !important;opacity:1}
          .model-main-wrap{position:absolute;left:50%;top:50%;transform:translate(-50%,-46%) scale(.98);background:#fff;height:fit-content;max-width:440px;width:100%;border-radius:0;opacity:0;transition:opacity .25s ease, transform .25s ease;overflow-y:auto;margin-top:0;-ms-scroll-chaining:none;overscroll-behavior:none;padding:40px 30px 30px;border-radius:8px}
          .model-wrap.is-open .model-main-wrap{opacity:1;transform:translate(-50%,-50%) scale(1)}
          .model-close-btn,.end-close-btn,.open-modal-btn{cursor:pointer}
          button.model-close-btn{position:absolute;right:6px;top:4px;box-shadow:none;color:transparent;width:40px;height:40px;padding:10px;margin-left:auto;display:block;font-size:20px;border:none;background:none}
          button.model-close-btn:before{content:'✕';color:#000;font-size:24px}
          button.end-close-btn{background-color:#305456;color:#fff;border:none;border-radius:2px;padding:10px 33px;font-size:16px;font-weight:500;text-transform:uppercase;cursor:pointer;display:block;margin-left:auto;margin-right:auto;margin-top:30px;font-family:var(--typeBasePrimary,var(--typeBaseFallback))}
          .getsunmedpdpsusbsavesubsinfocontent .model-main-wrap .content-wrap p{color:#000;font-size:18px;line-height:1.5;margin:0 0 20px;text-align:left}
        </style>

    </fieldset>`;
  }

  updated = (changed) => {
    if (changed.has('product') && this.product) {
      this.key = this.key ? this.key : this.product.id;

      this.skioSellingPlanGroups = (this.product.selling_plan_groups || []).filter(
        (selling_plan_group) => selling_plan_group.app_id === 'SKIO'
      );

      this.skioSellingPlanGroups.forEach((group) => {
        group.selling_plans.sort((a, b) => {
          const an = parseInt(String(a.name).replace(/\D/g, ''), 10);
          const bn = parseInt(String(b.name).replace(/\D/g, ''), 10);
          return an - bn;
        });
      });  
      
	  if(window.__PRODUCT_VARIANT_METAFIELDS__) {
      for (const variantMetafields of window.__PRODUCT_VARIANT_METAFIELDS__) {
        let variant = this.product.variants.find(variant => String(variant.id) == variantMetafields.id);
        if(variant) {
          variant.metafields = variantMetafields;
        }
      }
    }
      this.selectedVariant = this.product.variants.find(variant => String(variant.id) == this.selectedVariant.id);
    }

    if (changed.has('selectedVariant') && this.selectedVariant) {
      this.selectedVariant = this.product.variants.find(variant => String(variant.id) == this.selectedVariant.id);
	  this.availableSellingPlanGroups = this.skioSellingPlanGroups.filter((selling_plan_group) =>
        selling_plan_group.selling_plans.some((selling_plan) =>
          this.selectedVariant.selling_plan_allocations.some(
            (selling_plan_allocation) => selling_plan_allocation.selling_plan_id === selling_plan.id
          )
        )
      );

      if (this.availableSellingPlanGroups?.length > 0) {
        this.availableSellingPlanGroups.forEach((group) => {
          if (this.defaultFrequency) {
            const sp = group.selling_plans.find((x) =>
              x.name.toLowerCase().includes(this.defaultFrequency.toLowerCase())
            );
            group.selected_selling_plan = sp || group.selling_plans[0];
          } else {
            group.selected_selling_plan = group.selling_plans[0];
          }
        });
      }

      this.selectedSellingPlan = null;
      this.selectedSellingPlanGroup = null;
      this.purchaseOption = 'onetime';

      this.updateExternalPrice();
      this.requestUpdate();
      this.syncSwymButtonState();
    }
  }

  updateExternalPrice() {
    document.querySelectorAll(this.externalPriceSelector).forEach((el) => {
      el.innerHTML = this.price(this.selectedSellingPlan);
    });

    document.querySelectorAll(this.externalPriceSelectorWithCurrency).forEach((el) => {
      el.innerHTML = this.price(this.selectedSellingPlan) + ' ' + this.currency;
    });

    document.querySelectorAll(this.externalSaveSelector).forEach((el) => {
      let saveAmount = 0;
      if (this.selectedVariant?.compare_at_price > this.selectedVariant?.price) {
        saveAmount = this.selectedVariant.compare_at_price - this.selectedVariant.price;
      }
      if (this.selectedSellingPlan) saveAmount += this.discount(this.selectedSellingPlan).amount;
      if (saveAmount <= 0) return;
      el.innerHTML = 'Save ' + this.money(saveAmount);
    });
  }

  selectSellingPlanGroup(group) {
    this.selectedSellingPlanGroup = group;
    this.selectedSellingPlan = group?.selected_selling_plan || null;
    this.purchaseOption = group ? 'subscription' : 'onetime';
    this.updateExternalPrice();
  }

  selectSellingPlan(element, group) {
    const selling_plan = group.selling_plans.find((x) => String(x.id) == String(element.value));
    if (selling_plan) {
      group.selected_selling_plan = selling_plan;
      this.selectedSellingPlan = selling_plan;
      this.updateExternalPrice();
      this.requestUpdate();
    }
  }

  money(price) {
    return this.moneyFormatter.format(price / 100.0);
  }

  discount(selling_plan) {
    if (!selling_plan) return { percent: '0%', amount: 0 };

    const price_adjustment = selling_plan.price_adjustments[0];
    const discount = { percent: '0%', amount: 0 };
    const price = this.selectedVariant.price;

    switch (price_adjustment.value_type) {
      case 'percentage':
        discount.percent = `${price_adjustment.value}%`;
        discount.amount = Math.round((price * price_adjustment.value) / 100.0);
        break;
      case 'fixed_amount':
        discount.percent = `${Math.round(((price_adjustment.value * 1.0) / price) * 100.0)}%`;
        discount.amount = price_adjustment.value;
        break;
      case 'price':
        discount.percent = `${Math.round((((price - price_adjustment.value) * 1.0) / price) * 100.0)}%`;
        discount.amount = price - price_adjustment.value;
        break;
    }

    return discount;
  }

  price(selling_plan, formatted = true) {
    const v = this.selectedVariant.price - this.discount(selling_plan).amount;
    return formatted ? this.money(v) : v;
  }

  fetchProduct = (handle) => {
    return fetch(`/products/${handle}.js`)
      .then((response) => response.json())
      .then((product) => {
        this.product = product;
        this.selectedVariant = product.variants[0];
        return product;
      });
  }
}

customElements.define('skio-plan-picker', SkioPlanPickerComponent);